import { WrappedTypography } from '@issuemanager/apps/client/components';
import { WithTheme } from '@issuemanager/apps/client/theme';
import { TypographyProps, styled } from '@mui/material';

export const TimelineEventTypography = styled(WrappedTypography)<
  WithTheme<TypographyProps>
>(({ theme }) => ({
  fontWeight: theme.tokens.semantic.fontWeight.emphasis.value,
  fontSize: theme.tokens.semantic.fontSize.text.sm.value,
  color: theme.tokens.semantic.color.placeholder.value,
}));
